// ChatLeadsDialog.tsx
import React, { useState } from "react";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  Alert,
} from "@mui/material";
import { PersonAddAltRounded } from "@mui/icons-material";
import { Dialog } from "../../../components/Dialogs/Dialog";
import { useNavigate } from "react-router-dom";

interface ChatLeadsDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: () => Promise<void>;
}

export const ChatLeadsDialog: React.FC<ChatLeadsDialogProps> = ({
  open,
  onClose,
  onSave,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const handleSave = async () => {
    setLoading(true);
    setError(null);

    try {
      await onSave();
      setSuccess(true);
      setTimeout(() => {
        handleClose();
        navigate("/chat-leads")
      }, 2000);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to create chat leads");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setError(null);
      setSuccess(false);
      onClose();
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      title="Create Chat Leads"
      size="sm"
    >
      <Box p={2}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Do you want to Create Chat Leads?
        </Typography>

        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            Chat leads created successfully!
          </Alert>
        )}

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
      </Box>
      
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button 
          onClick={handleClose} 
          disabled={loading}
          color="inherit"
        >
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          disabled={loading || success}
          variant="contained"
          color="primary"
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? "Creating..." : success ? "Success!" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};